import { faThLarge } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import currencyConverter from "../Assets/currency-conveter.png";
import energyUsageCalculator from "../Assets/energy-usage-calculator.png";
import React from "react";

function Portfolio() {
  return (
    <div className="mt-2">
      <div className="jumbotron text-center bg-light border">
        <FontAwesomeIcon
          icon={faThLarge}
          fontSize={128}
          className="mb-5 text-danger"
        />
        <h2>Our Portfolio</h2>
        <p>
          Discover success in our portfolio: innovative software solutions
          crafted by MileSoft.
        </p>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="card bg-light p-3 text-center">
              <img
                src={currencyConverter}
                alt="Currency Conveter"
                width={64}
                height={64}
                className="m-2 text-danger rounded mx-auto d-block"
              />
              <div className="card-body text-center">
                A currency converter app swiftly and effortlessly converts the
                value of one currency to another. Users input the desired amount
                and select the currencies, and the app displays the converted
                value using up-to-date exchange rates.
              </div>
              <a href="https://play.google.com/store/apps/details?id=co.milesoft.currencyconverter&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img
                  alt="Get it on Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  height={64}
                />
              </a>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card bg-light p-3 text-center">
              <img
                src={energyUsageCalculator}
                alt="Currency Conveter"
                width={64}
                height={64}
                className="m-2 text-danger rounded mx-auto d-block"
              />
              <div className="card-body text-center">
                The Energy Usage Calculator is a user-friendly app for tracking
                and optimizing energy consumption. Input data for appliances,
                get accurate calculations, and make informed decisions to reduce
                your environmental footprint.
              </div>
              <a href="https://play.google.com/store/apps/details?id=co.milesoft.energyusagecalculator&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img
                  alt="Get it on Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  height={64}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container">&nbsp;</div>
    </div>
  );
}

export default Portfolio;
